import React, { useEffect } from "react";
import Header from "../body/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountryById,
  countrybyId,
} from "./../../redux/reducers/Countriesid";
import { useParams } from "react-router-dom";
import "./Detail.css";

const Detail = () => {
  const dispatch = useDispatch();
  let countries = useSelector(countrybyId);
  let params = useParams();

  useEffect(() => {
    dispatch(getCountryById(params.id));
  }, [dispatch]);

  return (
    <>
      <Header />
      <div className="container-detail">
        <div className="detail-img">
          {" "}
          <img
            src={countries.length > 0 ? countries[0].flag : ""}
            width={400}
            height={300}
            alt={countries.length > 0 ? countries[0].name : ""}
          />
        </div>{" "}
        <div className="detail-info">
          <h3>Name: {countries.length > 0 ? countries[0].name : ""} </h3>
          <h3>Capital: {countries.length > 0 ? countries[0].capital : ""}</h3>
          <h3>
            Continent: {countries.length > 0 ? countries[0].continent : ""}
          </h3>{" "}
          <h3>
            Subcontinent:{" "}
            {countries.length > 0
              ? countries[0].subcontinent === null
                ? "-"
                : countries[0].subcontinent
              : ""}
          </h3>{" "}
          <h3>
            Population: {countries.length > 0 ? countries[0].population : ""}
          </h3>
          <h3>
            Google Maps:{" "}
            <a href={countries.length > 0 ? countries[0].maps : ""}>
              Link to Google maps
            </a>
          </h3>
          <h3>
            Activities:{" "}
            {countries.length > 0
              ? countries[0].activities
                ? countries[0].activities.length > 0
                  ? countries[0].activities.map((act) => act.name + ",")
                  : "No activities for this country yet"
                : "No activities for this country yet"
              : ""}
          </h3>
        </div>
      </div>
    </>
  );
};

export default Detail;
